<div class="containers ">
    <mat-tab-group class="global-tab-view" *ngIf="currentFilingItem" (selectedTabChange)="onSelectedNavBarChange()"
                   [selectedIndex]="selectedTabIndex">
        <mat-tab *ngFor="let item of navbars;index as i" label="{{item.name}}">
            <div class="date-filed-filing-details" *ngIf="selectedTabIndex === 1">
                <div class="filing-type-selection flex flex-col justify-start items-start">
                    <mat-form-field appearance="outline" class="full-grow-no-shrink-no-basis">
                        <mat-select [(value)]="selectedFilingType" (selectionChange)="onFilingTypeChange($event)">
                            <mat-option *ngFor="let filingType of filingTypes" [value]="filingType">
                                {{filingType}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
<!--                    <div class="cbc-form-redirection" (click)="NavigateToCbCForms()">-->
<!--                        View Required Form In CbC Forms-->
<!--                    </div>-->
                </div>
                <div class="due-date-and-status">
                    <div class="filing-due-date">
                        <div>Due Date</div>
                        <div style="padding-top: 10px;">{{dueDate.displayText}}</div>
                    </div>
                    <div class="filing-status-display">
                        <div>Status</div>
                        <div *ngIf="isNotApplicable==false" class="filing-status-applicable">
                            <div class="status-color" [ngClass]="filingStatusColor"></div>
                            <div class="display-text">
                                {{currentFilingStatus}}
                            </div>
                        </div>
                        <div style="padding-top: 10px;" *ngIf="isNotApplicable">
                            <div>N/A</div>
                        </div>

                    </div>
                </div>
                <div class="filing-status" *ngIf="dueDate.displayText != 'N/A'">
                    <div class="filing-status-header"><strong>Filing Status</strong></div>
                    <div class="filing-status-dropdown">
                        <mat-form-field appearance="outline" class="full-grow-no-shrink-no-basis">
                            <mat-select [(value)]="selectedFilingStatus"
                                        (selectionChange)="onFilingStatusChange($event)">
                                <mat-option *ngFor="let filingstatus of filingstatuses" [value]="filingstatus">
                                    {{filingstatus}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="filing-completed" *ngIf="selectedFilingStatus === 'Completed' && !isNotApplicable">
                        <div class="filing-completed-header"><strong>Filing Date</strong></div>
                        <div class="filing-completed-date-input m-b-10">
                            <mat-form-field appearance="outline" class="orbitax-date-picker">
                                <input matInput [(value)]="dateFiled" [matDatepicker]="picker1"
                                       (dateChange)="filingDateChanged($event)"
                                       (dateInput)="dateInput()">
                            </mat-form-field>
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                        </div>
                        <div class="filing-completed-file-input">
                            <particle-file-selector [(file)]="fileToUpload" class="flex flex-col"
                                                    [legend]="'Attch Completed Form'"
                                                    [acceptedTypes]="acceptedFileTypes"
                                                    (fileChange)="onFileChange($event)">
                            </particle-file-selector>
                            <div *ngIf="existingUploadFileModel && existingUploadFileModel.fileName"
                                 class="note m-t-10">
                                <div class="existing-file-name" style="color: #1976d2; cursor: pointer; text-decoration: underline;" (click)="downloadExistingFile()">{{existingUploadFileModel.fileName}}</div>
                                <mat-icon style="cursor: pointer;" (click)="clearExistingUploadedFileModel()">clear
                                </mat-icon>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="submit-filing" *ngIf="dueDate.displayText != 'N/A'">
                    <button class="action-button" (click)="onSave()" mat-button>Save</button>
                </div>
            </div>

            <div class="date-filed-related-links">
                <ul class="related-link" *ngIf="selectedTabIndex === 0">
                    <li *ngFor="let link of relatedLinks">
                        <a [href]="link.url" target="_blank">{{link.title}}</a>
                    </li>
                </ul>
            </div>
        </mat-tab>
    </mat-tab-group>

    <div *ngIf="currentFilingItem==undefined" class="no-filing-items-selected">

        <div class="empty-section">
            <div class="wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
                    <path
                            d="M40.875 10.75L48 8L50.625 1C50.75 0.375 51.375 0 52 0C52.5 0 53.125 0.375 53.25 1L56 8L63 10.75C63.625 10.875 64 11.5 64 12C64 12.625 63.625 13.25 63 13.375L56 16L53.25 23.125C53.125 23.625 52.5 24 52 24C51.375 24 50.75 23.625 50.625 23.125L48 16L40.875 13.375C40.25 13.25 40 12.625 40 12C40 11.5 40.25 10.875 40.875 10.75ZM32.125 23.5L46.375 30C47.125 30.375 47.625 31.125 47.625 31.875C47.625 32.625 47.125 33.375 46.375 33.75L32.125 40.25L25.625 54.5C25.25 55.25 24.5 55.75 23.75 55.75C23 55.75 22.25 55.25 22 54.5L15.375 40.25L1.125 33.75C0.375 33.375 0 32.625 0 31.875C0 31.125 0.375 30.375 1.125 30L15.375 23.5L22 9.25C22.25 8.5 23 8 23.75 8C24.5 8 25.25 8.5 25.625 9.25L32.125 23.5ZM50.625 41C50.75 40.375 51.375 40 52 40C52.5 40 53.125 40.375 53.25 41L56 48L63 50.75C63.625 50.875 64 51.5 64 52C64 52.625 63.625 53.25 63 53.375L56 56L53.25 63.125C53.125 63.625 52.5 64 52 64C51.375 64 50.75 63.625 50.625 63.125L48 56L40.875 53.375C40.25 53.25 40 52.625 40 52C40 51.5 40.25 50.875 40.875 50.75L48 48L50.625 41Z"
                            fill="url(#paint0_linear_990_407)"/>
                    <defs>
                        <linearGradient id="paint0_linear_990_407" x1="47.8476" y1="-46.08" x2="-18.4242" y2="-33.1213"
                                        gradientUnits="userSpaceOnUse">
                            <stop stop-color="#C728C1"/>
                            <stop offset="1" stop-color="#1EA9D6"/>
                        </linearGradient>
                    </defs>
                </svg>
                <h3>No Filing Items Selected</h3>
            </div>
        </div>


    </div>
</div>
